import { QueryClient } from "@tanstack/react-query"

/**
 * Single shared QueryClient. Defaults are tuned for an admin panel:
 *   - staleTime 30s: lists feel snappy on revisit but won't show ancient data
 *   - retry 1: don't drown a flaky backend in retries
 *   - refetchOnWindowFocus true: admins context-switch a lot; default behaviour
 *
 * Override per-query as needed.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: 0,
    },
  },
})
